import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {createPortal} from 'react-dom'
import {useDropzone} from 'react-dropzone'
import Swal from 'sweetalert2'
import {uploadEstampDoc} from '../EstampRequestAPI'
import styles from '../EstampStyles/EstampStyle.module.scss'
import {viewEstampRequestDataType} from '../EstampRequestDataType'

const province = [
  {
    country_id: 1,
    province_code: 'AP',
    province_id: 1,
    province_name: 'Andhra Pradesh',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'AR',
    province_id: 2,
    province_name: 'Arunachal Pradesh',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'AS',
    province_id: 3,
    province_name: 'Assam',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'BR',
    province_id: 4,
    province_name: 'Bihar',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'CG',
    province_id: 5,
    province_name: 'Chhattisgarh',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'GA',
    province_id: 6,
    province_name: 'Goa',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'GJ',
    province_id: 7,
    province_name: 'Gujarat',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'HR',
    province_id: 8,
    province_name: 'Haryana',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'HP',
    province_id: 9,
    province_name: 'Himachal Pradesh',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'JH',
    province_id: 10,
    province_name: 'Jharkhand',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'KA',
    province_id: 11,
    province_name: 'Karnataka',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'KL',
    province_id: 12,
    province_name: 'Kerala',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'MP',
    province_id: 13,
    province_name: 'Madhya Pradesh',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'MH',
    province_id: 14,
    province_name: 'Maharashtra',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'MN',
    province_id: 15,
    province_name: 'Manipur',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'ML',
    province_id: 16,
    province_name: 'Meghalaya',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'MZ',
    province_id: 17,
    province_name: 'Mizoram',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'NL',
    province_id: 18,
    province_name: 'Nagaland',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'OR',
    province_id: 19,
    province_name: 'Odisha',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'PB',
    province_id: 20,
    province_name: 'Punjab',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'RJ',
    province_id: 21,
    province_name: 'Rajasthan',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'SK',
    province_id: 22,
    province_name: 'Sikkim',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'TN',
    province_id: 23,
    province_name: 'Tamil Nadu',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'TG',
    province_id: 24,
    province_name: 'Telangana',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'TR',
    province_id: 25,
    province_name: 'Tripura',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'UP',
    province_id: 26,
    province_name: 'Uttar Pradesh',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'UT',
    province_id: 27,
    province_name: 'Uttarakhand',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'WB',
    province_id: 28,
    province_name: 'West Bengal',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'AN',
    province_id: 29,
    province_name: 'Andaman and Nicobar Islands',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'CH',
    province_id: 30,
    province_name: 'Chandigarh',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'DH',
    province_id: 31,
    province_name: 'Dadra and Nagar Haveli',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'DD',
    province_id: 32,
    province_name: 'Daman and Diu',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'LD',
    province_id: 33,
    province_name: 'Lakshadweep',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'LA',
    province_id: 34,
    province_name: 'Ladakh',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'DL',
    province_id: 35,
    province_name: 'Delhi',
    province_status: 1,
  },
  {
    country_id: 1,
    province_code: 'PY',
    province_id: 36,
    province_name: 'Puducherry',
    province_status: 1,
  },
]
const modalsRoot = document.getElementById('root-modals') || document.body

const ViewEstampRequest = ({
  show,
  handleClose,
  request,
  formatDate,
  getListEstamp,
  requestStatus,
}: viewEstampRequestDataType) => {
  const [uploadDocumentLoading, setUploadDocumentLoading] = useState<boolean>(false)
  const [error, setError] = useState<string>('')
  const signingRequestJson = JSON.parse(request.signing_request_json)
  // dropzone code start
  const {acceptedFiles, fileRejections, getRootProps, getInputProps, isDragActive} = useDropzone({
    maxFiles: 1,
    accept: {
      'application/pdf': [],
    },
  })

  const acceptedFileItems = acceptedFiles.map((file) => {
    return (
      // @ts-ignore
      <li key={file.path}>
        {
          // @ts-ignore
          file.path
        }{' '}
        - {file.size} bytes
      </li>
    )
  })

  const fileRejectionItems = fileRejections.map(({file, errors}) => (
    // @ts-ignore
    <li key={file.path}>
      {
        // @ts-ignore
        file.path
      }{' '}
      - {file.size} bytes
      <ul>
        {errors.map((e) => (
          <li key={e.code}>{e.message}</li>
        ))}
      </ul>
    </li>
  ))
  // dropzone code ends

  const handleSubmitPdf = () => {
    if (acceptedFiles.length === 1 && show) {
      setUploadDocumentLoading(true)
      const reader = new FileReader()
      reader.onloadend = async () => {
        const base64String = reader.result
        const res = await uploadEstampDoc(
          show,
          // @ts-ignore
          base64String.split(',')[1]
        )
        if (res.status === 200) {
          setUploadDocumentLoading(false)
          getListEstamp()
          handleClose()
          acceptedFiles.pop()
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: res.data.msg.charAt(0).toUpperCase() + res.data.msg.slice(1),
            text: res.data.msg_details,
            allowOutsideClick: true,
          })
        } else {
          setUploadDocumentLoading(false)
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: res.data.msg.charAt(0).toUpperCase() + res.data.msg.slice(1),
            text: res.data.msg_details,
            allowOutsideClick: true,
          })
        }
      }
      reader.readAsDataURL(acceptedFiles[0])
    } else {
      setError('Error: No document found, add document to upload')
    }
  }

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        setError('')
      }, 2000)
    }
  }, [error])

  const findProvince = (id: number) => {
    const foundProvince = province.find((province) => province.province_id === id)
    return foundProvince ? foundProvince.province_name : 'Province Not Found'
  }
  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-900px'
      show={show ? true : false}
      onHide={handleClose}
      backdrop={true}
    >
      {/* Begin: Modal header */}
      <div className='modal-header pt-5 pb-5'>
        {/* Begin: Modal Heading */}
        <h2>
          {requestStatus === 1
            ? 'Completed Requests'
            : requestStatus === 2
            ? 'Pending Requests'
            : 'Requests'}
        </h2>
        {/* End: Modal Heading */}
        {/* Begin::Close button */}
        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
          <i className='bi bi-x-lg' onClick={handleClose}></i>
        </div>
        {/* end::Close button */}
      </div>
      {/* End: Modal header */}
      {error && (
        <div className='h-20px d-flex justify-content-center' style={{backgroundColor: 'red'}}>
          <div className='fv-help-block' style={{color: 'white'}}>
            {error}
          </div>
        </div>
      )}
      {/* Begin: Modal body */}
      <div className='d-flex w-100 px-6 pt-4 flex-wrap'>
        <div className={styles.max_w_50}>
          <span className='text-muted fw-semibold text-muted d-block fs-6'>User Name</span>
          <p className='d-flex flex-column fs-4 '>
            <span className='text-dark fw-bold text-hover-primary fs-6'>
              {request.accouont_holder_name}
            </span>
            <span className='text-muted fw-semibold text-muted d-block fs-7'>
              {request.email_id}
            </span>
          </p>
        </div>
        <div className={styles.max_w_50}>
          <span className='text-muted fw-semibold text-muted d-block fs-6'>Property Name</span>
          <p className='text-dark fw-bold text-hover-primary fs-6'>{request.property_title}</p>
        </div>
        <div className={styles.max_w_50}>
          <span className='text-muted fw-semibold text-muted d-block fs-6'>eStamp Amount</span>
          <p className='text-dark fw-bold text-hover-primary fs-6'>
            {`₹ ${request.estamp_amount}`}
          </p>
        </div>
        <div className={styles.max_w_50}>
          <span className='text-muted fw-semibold text-muted d-block fs-6'>eStamp State</span>
          <p className='text-dark fw-bold text-hover-primary fs-6'>
            {findProvince(signingRequestJson.estamp_state)}
          </p>
        </div>
        {signingRequestJson?.lessee && signingRequestJson?.lessor && (
          <>
            <div className={styles.max_w_50}>
              <span className='text-muted fw-semibold text-muted d-block fs-6'>Lessor Name</span>
              <p className='d-flex flex-column fs-4 '>
                <span className='text-dark fw-bold text-hover-primary fs-6'>
                  {signingRequestJson?.lessor?.name}
                </span>
                <span className='text-muted fw-semibold text-muted d-block fs-7'>
                  {`${signingRequestJson.lessor_age} ${
                    signingRequestJson.lessor_age <= 1 ? 'Year' : 'Years'
                  }`}
                </span>
              </p>
            </div>
            <div className={styles.max_w_50}>
              <span className='text-muted fw-semibold text-muted d-block fs-6'>Lessee Name</span>
              <p className='d-flex flex-column fs-4 '>
                <span className='text-dark fw-bold text-hover-primary fs-6'>
                  {signingRequestJson?.lessee?.name}
                </span>
                <span className='text-muted fw-semibold text-muted d-block fs-7'>{`${
                  signingRequestJson.lessee_age
                } ${signingRequestJson.lessee_age <= 1 ? 'Year' : 'Years'}`}</span>
              </p>
            </div>
          </>
        )}
        {signingRequestJson?.signers &&
          signingRequestJson?.signers[0] &&
          signingRequestJson?.signers[1] && (
            <>
              <div className={styles.max_w_50}>
                <span className='text-muted fw-semibold text-muted d-block fs-6'>Signer 1</span>
                <p className='d-flex flex-column fs-4 '>
                  <span className='text-dark fw-bold text-hover-primary fs-6'>
                    {signingRequestJson?.signers[0]?.name}
                  </span>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    {signingRequestJson?.signers[0]?.identifier}
                  </span>
                </p>
              </div>
              <div className={styles.max_w_50}>
                <span className='text-muted fw-semibold text-muted d-block fs-6'>Signer 2</span>
                <p className='d-flex flex-column fs-4 '>
                  <span className='text-dark fw-bold text-hover-primary fs-6'>
                    {signingRequestJson?.signers[1]?.name}
                  </span>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    {signingRequestJson?.signers[1]?.identifier}
                  </span>
                </p>
              </div>
            </>
          )}
      </div>
      <p className='text-muted my-1 px-6 mb-5'>{`Created at ${formatDate(
        new Date(request.created_date)
      )}`}</p>
      {request.estamp_status_msg === 'Pending' && (
        <>
          {/*begin::Dropzone field */}
          <div className='border border-2 rounded border-dashed row p-2 bg-white mx-4 mt-4'>
            <section className='border border-2 rounded border-primary border-dashed h-100 symbol bg-light-primary'>
              <div
                {...getRootProps({
                  className: 'py-4 d-flex flex-column justify-content-center align-items-center',
                })}
              >
                <input {...getInputProps()} />
                {isDragActive ? (
                  <p>Drop the files here...</p>
                ) : (
                  <p>Drag and drop files here, or click to select files</p>
                )}
                <i className='bi bi-file-earmark-arrow-up-fill fs-4x btn btn-active-color-primary py-0 mb-3'></i>
                <span className='text-primary fs-7'>Type: *.pdf only</span>
                <span className='text-primary fs-7'>Max document:1</span>
              </div>
            </section>
          </div>

          <aside className='px-5'>
            {acceptedFileItems.length > 0 && (
              <div className='pt-2'>
                <h4>Document is ready to upload</h4>
                <ul>{acceptedFileItems}</ul>
              </div>
            )}
            {fileRejectionItems.length > 0 && (
              <div className='pt-2'>
                <span className='fv-help-block color-red'>
                  Upload only one file or select files with allowed formats only
                </span>
                {/* <ul>{fileRejectionItems}</ul> */}
              </div>
            )}
          </aside>
          {/*end::Dropzone field */}
          <div className='d-flex flex-column align-items-center pb-4'>
            <button
              type='button'
              onClick={handleSubmitPdf}
              className='btn btn-sm btn-primary shadow mt-3'
              style={{cursor: 'pointer'}}
              disabled={uploadDocumentLoading}
            >
              {uploadDocumentLoading ? (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Processing...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              ) : (
                <span>Upload eStamp</span>
              )}
            </button>
          </div>
        </>
      )}
    </Modal>,
    modalsRoot
  )
}

export default ViewEstampRequest
